import React, { useState } from 'react';

import { ReactComponent as ChevronLeft } from '../../../../../../assets/icons/icon_chevron_left.svg';
import { ReactComponent as ChevronRight } from '../../../../../../assets/icons/icon_chevron_right.svg';
import Response from '../../../../../../networking/models/Response';

interface Props {
    responses: Response[];
}

// TODO: Replace with paginated responses
const UniversityGeneralReviewsContent: React.FC<Props> = (props) => {

    const [currentReview, setCurrentReview] = useState<number>(0);

    const reviews = props.responses.filter(r => r.comment.length);

    const changeReview = (position: number) => {
        if ((currentReview === 0 && position === -1) || (currentReview === props.responses.length - 1 && position === 1)) {
            return;
        }

        setCurrentReview(currentReview + position);
    }

    return (
        <div className="university-general__reviews">
            <h2 className="university-general__title">REVIEWS</h2>
            <p className="university-general__review-title">Review</p>

            {
                reviews.map((review, index) => {
                    return (
                        <div className={`university-general__review ${index !== currentReview && "university-general__review--disabled"}`} key={index}>
                            <div className="university-general__review-stars">
                                {
                                    // TODO: Add starts in back-end
                                    // Array(review.).fill("").map((value, index) => <Star key={index} />)
                                }
                            </div>
                
                            <div className="university-general__review-text">{review.comment}</div>
                        </div>
                    )
                })
            }

            <div className="university-general__review-buttons">
                <div
                    className={`
                                    university-general__review-button
                                    ${currentReview === 0 && "university-general__review-button--disabled"}  
                                `}
                    onClick={() => changeReview(-1)}
                >
                    <ChevronLeft />
                </div>
                <div
                    className={`
                                    university-general__review-button
                                    ${(currentReview === reviews.length - 1) && "university-general__review-button--disabled"}
                                `}
                    onClick={() => changeReview(1)}
                >
                    <ChevronRight />
                </div>
            </div>
        </div>
    )
}

export default UniversityGeneralReviewsContent;
